import $ from 'jquery'
import Splide from '@splidejs/splide'
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll'
import { Fancybox } from '@fancyapps/ui'


$('.js-premium-place-slider').each(function() {
    var $this = $(this);
    const splideElement = $('.header-place__slider');
    const slidesCount = splideElement.find('.splide__slide').length;
    const autoScroll = {speed: .3}
    var premiumPlaceSplide = new Splide( $this[0], {
        type    : 'loop',
        drag: slidesCount <= 2 ? false : 'free',
        arrows: false,
        pagination: false,
        autoHeight: true,
        focus: 'center',
        autoWidth: true,
        trimSpace: true,
        gap : '30px',
        autoScroll: slidesCount <= 2 ? false : autoScroll,
        breakpoints: {
            992: {
                drag: true,
                perPage: 1,
                autoHeight: false,
                autoWidth: false,
                autoplay: true,
                interval: 5000,
                gap : '0',
            },
        }
    });

    if ( $this.hasClass('is-mobile') ) {
        premiumPlaceSplide.mount()
    }
    else {
        premiumPlaceSplide.mount({ AutoScroll })
        $(document).ready(function() {
            pauseSliderOnMob()
        });

        $(window).resize(function() {
            pauseSliderOnMob()
        });

        function pauseSliderOnMob() {
            if ( ! window.matchMedia('(min-width: 992px)').matches ) {
                premiumPlaceSplide.Components.AutoScroll.pause()
            }
            else {
                premiumPlaceSplide.Components.AutoScroll.play()
            }
        }
    }

    premiumPlaceSplide.on('moved', function(newIndex) {
        $('.js-index').text(newIndex + 1);
    });
});

Fancybox.bind(`[data-gallery="gallery-premium-place"]`, {
    groupAll: true,
    Toolbar: {
        display: {
            left: [],
            middle: [],
            right: ['close'],
        },
    },
    Thumbs: {
        type: 'classic',
    },
})
